"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkExtent = exports.bboxToString = void 0;
function bboxToString(bbox, bboxDigits) {
    var _a = __read(bbox, 4), xmin = _a[0], ymin = _a[1], xmax = _a[2], ymax = _a[3];
    return [
        typeof xmin === "number" && typeof bboxDigits === "number"
            ? xmin.toFixed(bboxDigits)
            : xmin.toString(),
        typeof ymin === "number" && typeof bboxDigits === "number"
            ? ymin.toFixed(bboxDigits)
            : ymin.toString(),
        typeof xmax === "number" && typeof bboxDigits === "number"
            ? xmax.toFixed(bboxDigits)
            : xmax.toString(),
        typeof ymax === "number" && typeof bboxDigits === "number"
            ? ymax.toFixed(bboxDigits)
            : ymax.toString(),
    ].toString();
}
exports.bboxToString = bboxToString;
function checkExtent(extent) {
    var _a = __read(extent, 4), minX = _a[0], minY = _a[1], maxX = _a[2], maxY = _a[3];
    if (minX > maxX || minY > maxY) {
        throw new Error("the extent ".concat(extent, " seems malformed or else may contain \"wrapping\" which is not supported"));
    }
}
exports.checkExtent = checkExtent;
